<header>
  <div class="container-small">
    <div class="header">
      <div class="header__logo">
        <img src="assets/images/removia-logo-white.svg" alt="logo" />
      </div>
      <div class="lang-switcher">
        <!-- <button
          *ngFor="let l of lang.SUPPORTED_LANGS"
          (click)="lang.setLang(l)"
          [class.lang-btn-active]="lang.currentLang === l"
          class="lang-btn"
        >
          {{ l.toUpperCase() }}
        </button> -->
        <button
          class="lang-globe-btn"
          (click)="openLangModal()"
          [attr.aria-label]="'Change language'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path
              d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            />
          </svg>
          <span class="lang-globe-label">{{
            lang.currentLang.toUpperCase()
          }}</span>
        </button>
      </div>
      <div class="header__btn">
        <a href="#plan" id="scroll-down" class="desktop button default">
          <!-- Get protected -->
          {{ "buy-now.protected" | translate }}
        </a>
        <a href="#plan" id="scroll-down-mobile" class="mobile button default">
          Plan
        </a>
        <a href="#" target="_blank" class="button grad">
          <!-- Log in  -->
          {{ "buy-now.login" | translate }}
        </a>
      </div>
    </div>
  </div>
</header>
<app-landing-main></app-landing-main>
<main>
  <section class="planhi">
    <div class="container-extra-small">
      <div class="planhi__wrapper">
        <div class="planhi__title" id="plan">
          <!-- Take Back Control with the <span>Right</span> Plan -->
          {{ "buy_now_long_term.plans.title" | translate }}
          <span>{{
            "buy_now_long_term.plans.title-highlight" | translate
          }}</span>
          {{ "buy_now_long_term.plans.title-end" | translate }}
        </div>
        <div class="planhi__list">
          <div class="planhi__list__section">
            <div class="planhi__list__item best">
              <div class="planhi__list__item--save">
                <!-- Save 33% -->
                {{
                  "buy_now_long_term.plans.save" | translate : { percent: 33 }
                }}
              </div>
              <div class="planhi__list__item--inner">
                <div class="planhi__list__item--best">
                  <img src="assets/images/best-shape.svg" alt="shape" />
                  <span>
                    <!-- BEST VALUE -->
                    {{ "buy_now_long_term.plans.best-value" | translate }}
                  </span>
                </div>
                <div class="planhi__list__item--title">
                  <!-- 36-month plan -->
                  {{
                    "buy_now_long_term.plans.month-plan"
                      | translate : { months: 36 }
                  }}
                </div>
                <div class="planhi__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">22.00</span>
                  <span class="period">
                    <!-- /month -->
                    {{ "buy_now_long_term.plans.per-month" | translate }}
                  </span>
                </div>
                <div class="planhi__list__item--price-all">
                  <!-- You pay today: -->
                  {{ "buy_now_long_term.plans.pay-today" | translate }}
                </div>
                <div class="planhi__list__item--text">
                  <span>$792</span>
                  <!-- = 36 months *$22.00 -->
                  {{
                    "buy_now_long_term.plans.months-calculation"
                      | translate : { months: 36, price: "22.00" }
                  }}
                </div>

                <div style="position: relative; margin-bottom: 32px">
                  <a
                    href="#"
                    data-cell="standard"
                    data-fsc-action="Add,Checkout"
                    data-fsc-item-path-value="removia-36-months-hi"
                    target="_blank"
                    role="button"
                    rel="noreferrer noopener"
                    aria-label="callback button"
                    class="planhi__list__item--btn button white"
                  >
                    Choose Plan
                  </a>
                  <span class="fake-choose-plan">
                    {{ "buy_now_long_term.plans.choose-plan" | translate }}
                  </span>
                </div>
                <div class="planhi__list__item--list">
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 300 data brokers covered -->
                    {{
                      "buy_now_long_term.features.brokers-covered"
                        | translate : { count: 300 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 5 emails monitored -->
                    {{
                      "buy_now_long_term.features.emails-monitored"
                        | translate : { count: 5 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Up to 4 people secured -->
                    {{
                      "buy_now_long_term.features.people-secured"
                        | translate : { count: 4 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Quarterly opt-out requests -->
                    {{
                      "buy_now_long_term.features.quarterly-requests"
                        | translate
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Personal privacy dashboard -->
                    {{
                      "buy_now_long_term.features.privacy-dashboard" | translate
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="planhi__list__item">
              <div class="planhi__list__item--save">
                <!-- Save 21% -->
                {{
                  "buy_now_long_term.plans.save" | translate : { percent: 21 }
                }}
              </div>
              <div class="planhi__list__item--inner">
                <div class="planhi__list__item--title">
                  <!-- 24-month plan -->
                  {{
                    "buy_now_long_term.plans.month-plan"
                      | translate : { months: 24 }
                  }}
                </div>
                <div class="planhi__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">26.00</span>
                  <span class="period">
                    <!-- /month -->
                    {{ "buy_now_long_term.plans.per-month" | translate }}
                  </span>
                </div>
                <div class="planhi__list__item--price-all">
                  <!-- You pay today: -->
                  {{ "buy_now_long_term.plans.pay-today" | translate }}
                </div>
                <div class="planhi__list__item--text">
                  <span>$624</span>
                  <!-- = 24 months *$26.00 -->
                  {{
                    "buy_now_long_term.plans.months-calculation"
                      | translate : { months: 24, price: "26.00" }
                  }}
                </div>
                <div style="position: relative; margin-bottom: 32px">
                  <a
                    href="#"
                    data-cell="standard"
                    data-fsc-action="Add,Checkout"
                    data-fsc-item-path-value="removia-24-months-hi"
                    target="_blank"
                    role="button"
                    rel="noreferrer noopener"
                    aria-label="callback button"
                    class="planhi__list__item--btn button default"
                  >
                    Choose Plan
                  </a>
                  <span class="fake-choose-plan" style="color: white">
                    {{ "buy_now_long_term.plans.choose-plan" | translate }}
                  </span>
                </div>

                <div class="planhi__list__item--list">
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 200 data brokers covered -->
                    {{
                      "buy_now_long_term.features.brokers-covered"
                        | translate : { count: 200 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 3 emails monitored -->
                    {{
                      "buy_now_long_term.features.emails-monitored"
                        | translate : { count: 3 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Up to 2 people secured -->
                    {{
                      "buy_now_long_term.features.people-secured"
                        | translate : { count: 2 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Quarterly opt-out requests -->
                    {{
                      "buy_now_long_term.features.quarterly-requests"
                        | translate
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Personal privacy dashboard -->
                    {{
                      "buy_now_long_term.features.privacy-dashboard" | translate
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="planhi__list__item">
              <div class="planhi__list__item--inner">
                <div class="planhi__list__item--title">
                  <!-- 12-month plan -->
                  {{
                    "buy_now_long_term.plans.month-plan"
                      | translate : { months: 12 }
                  }}
                </div>
                <div class="planhi__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">33.00</span>
                  <span class="period">
                    <!-- /month -->
                    {{ "buy_now_long_term.plans.per-month" | translate }}
                  </span>
                </div>
                <div class="planhi__list__item--price-all">
                  <!-- You pay today: -->
                  {{ "buy_now_long_term.plans.pay-today" | translate }}
                </div>
                <div class="planhi__list__item--text">
                  <span>$396</span>
                  <!-- = 12 months *$33.00 -->
                  {{
                    "buy_now_long_term.plans.months-calculation"
                      | translate : { months: 12, price: "33.00" }
                  }}
                </div>
                <div style="position: relative; margin-bottom: 32px">
                  <a
                    href="#"
                    data-cell="standard"
                    data-fsc-action="Add,Checkout"
                    data-fsc-item-path-value="removia-12-months-hi"
                    target="_blank"
                    role="button"
                    rel="noreferrer noopener"
                    aria-label="callback button"
                    class="planhi__list__item--btn button default"
                  >
                    Choose Plan
                  </a>
                  <span class="fake-choose-plan" style="color: white">
                    {{ "buy_now_long_term.plans.choose-plan" | translate }}
                  </span>
                </div>

                <div class="planhi__list__item--list">
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 200 data brokers covered -->
                    {{
                      "buy_now_long_term.features.brokers-covered"
                        | translate : { count: 200 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 3 emails monitored -->
                    {{
                      "buy_now_long_term.features.emails-monitored"
                        | translate : { count: 3 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Up to 2 people secured -->
                    {{
                      "buy_now_long_term.features.people-secured"
                        | translate : { count: 2 }
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Quarterly opt-out requests -->
                    {{
                      "buy_now_long_term.features.quarterly-requests"
                        | translate
                    }}
                  </div>
                  <div class="planhi__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Personal privacy dashboard -->
                    {{
                      "buy_now_long_term.features.privacy-dashboard" | translate
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="planhi__info">
          <div class="planhi__info--bottom">
            <!-- By clicking Buy Now you automatically agree to the -->
            {{ "buy_now_long_term.footer.agreement" | translate }}
            <a href="https://removia.io/terms_of_use" target="_blank">
              <!-- Terms of Use -->
              {{ "buy_now_long_term.footer.terms" | translate }}
            </a>
            <!-- and -->
            {{ "buy_now_long_term.footer.and" | translate }}
            <a href="https://removia.io/privacy_policy" target="_blank">
              <!-- Privacy Policy -->
              {{ "buy_now_long_term.footer.privacy" | translate }}
            </a>
            <!-- of Removia -->
            {{ "buy_now_long_term.footer.of-removia" | translate }}
          </div>
          <!-- <img src="assets/images/trust.svg" alt="banner" /> -->
        </div>
      </div>
    </div>
  </section>
</main>
<app-landing-footer></app-landing-footer>
<div
  class="lang-modal-overlay"
  [class.active]="isLangModalOpen"
  (click)="closeLangModal()"
>
  <div class="lang-modal" (click)="$event.stopPropagation()">
    <div class="lang-modal__header">
      <span class="lang-modal__title">{{ "choose_language" | translate }}</span>
      <button class="lang-modal__close" (click)="closeLangModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="lang-modal__list">
      <button
        *ngFor="let l of langOptions"
        class="lang-modal__item"
        [class.lang-modal__item--active]="lang.currentLang === l.code"
        (click)="selectLang(l.code)"
      >
        <span class="lang-modal__flag">{{ l.flag }}</span>
        <span class="lang-modal__name">{{ l.name }}</span>
        <span class="lang-modal__code">{{ l.code.toUpperCase() }}</span>
        <svg
          *ngIf="lang.currentLang === l.code"
          class="lang-modal__check"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
